<script setup lang="ts">
// An input's live audio: the peak per source channel and the loudness per
// pair. On the Live tab with the picture and on the Audio tab with the
// history (Niels: both).
import { computed } from 'vue'
import type { Loudness } from '../../api'
import Meters from '../Meters.vue'

const props = defineProps<{ peak: number[]; loudness?: Loudness[] }>()
const pairs = computed(() =>
    (props.loudness ?? [])
        .map((l, p) => ({ ...l, pair: `${2 * p + 1}–${2 * p + 2}` }))
        .filter((l) => l.i > -100 || l.m > -100),
)
const lu = (v: number) => (v <= -100 ? '—' : v.toFixed(1))
</script>

<template>
    <div class="mt-3 rounded-md border border-line px-2.5 py-2">
        <div class="box-title">
            Source audio<span class="font-normal tracking-normal normal-case"
                >channels 0–{{ peak.length - 1 }} · dBFS peak (held)</span
            >
        </div>
        <Meters :db="peak" />
        <table v-if="pairs.length" class="mt-2 w-full table-fixed font-mono text-[11px] tabular-nums">
            <tr class="text-left text-fg-3">
                <th class="w-10 font-normal">LUFS</th>
                <th class="font-normal">momentary</th>
                <th class="font-normal">short-term</th>
                <th class="font-normal" title="gated, since the input started">integrated</th>
            </tr>
            <tr v-for="l in pairs" :key="l.pair">
                <td class="text-fg-2">{{ l.pair }}</td>
                <td>{{ lu(l.m) }}</td>
                <td>{{ lu(l.s) }}</td>
                <td>{{ lu(l.i) }}</td>
            </tr>
        </table>
    </div>
</template>
